module.exports = __webpack_public_path__ + "media/Tapping Play Again Button.8e110280.mp3";